import {createApi} from '@reduxjs/toolkit/query/react';

import httpBaseQuery from 'shared/api/rtk-query/httpBaseQuery';
import {ApiUrls} from 'shared/config/model/urls';

import {IMessengerChat, IMessengerChatAdd, INotifyChannelEdit} from '../model/INotifyChannel';

import {notifyChannelApiOptions, notifyChannelEndpoints} from './notifyChannelEndpoints';

export const telegramChatAPI = createApi({
    reducerPath: 'telegramChatAPI',
    baseQuery: httpBaseQuery(),
    ...notifyChannelApiOptions,
    endpoints: notifyChannelEndpoints<IMessengerChat, IMessengerChatAdd, INotifyChannelEdit>({
        list: ApiUrls.TELEGRAM_CHATS,
        item: ApiUrls.TELEGRAM_CHAT,
        testNotify: ApiUrls.TELEGRAM_CHAT_SEND_TEST_NOTIFY,
    }),
});
